export const SET_XSRF_TOKEN = 'SetXsrfTokenAction';
export const XsrfDefaultSettings = { token: 'undefined' };

export const xsrfReducer = (state = XsrfDefaultSettings, action) => {
    switch (action.type) {
        case SET_XSRF_TOKEN:
            return { token: action.payload };
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            // const exhaustiveCheck: never = action;
            break;
    }
    return state;
};

